var global = require('./$.global')
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6682bo/master/~/vue2-google-maps/~/core-js/library/modules/$.shared.js
// module id = 102
// module chunks = 1